<template>
	<div class="discount">
		<div v-for="item in dataList" :key="item.id" class="discount-item" @click="toDetailClick(item)">
			<img class="discount-img" :src="item.picUrl" />
			<div class="discount-right">
				<div>
					<div class="discount-title">{{ item.title }}</div>
					<div class="discount-content">{{ item.content }}</div>
				</div>
				<div class="discount-footer">
					<div class="discount-amount">
						<span>{{ item.amounts }}</span>
						元
					</div>
					<div
						class="discount-btn"
						:class="{ 'discount-received': item.useState === '1' }"
						@click.stop="toUseClick(item)">
						<span v-if="item.goodsType === '1'">
							{{ item.useState | useBtnTe }}
						</span>
						<span v-else>
							{{ item.useState | useBtnText }}
						</span>
					</div>
				</div>
			</div>
			<div class="discount-count"> X {{ item.count }}张券 </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DiscountItem',
		props: {
			dataList: {
				type: Array,
				default: () => []
			},
			regionNo: {
				type: String,
				default: ''
			}
		},
		emits: ['showMsg'],
		filters: {
			useBtnTe(val) {
				switch (val) {
					case '0':
						return '去激活'
					case '1':
						return '已激活'
					default:
						return '已激活'
				}
			},
			useBtnText(val) {
				switch (val) {
					case '0':
						return '领取'
					case '2':
						return '下月使用'
					case '1':
						return '已领取'
					default:
						return '下月使用'
				}
			}
		},
		data() {
			return {}
		},
		created() {},
		methods: {
			/** 查看详情 */
			toDetailClick(item) {
				// if (this.isNeedLogin) {
				//   this.popupVisible = true;
				//   return;
				// }
				this.$router.push({
					name: 'discountsDetail',
					params: {
						id: item.id,
						num: item.count,
						regionNo: this.regionNo,
						goodsType: item.goodsType
					}
				})
			},
			/** 去使用 */
			toUseClick(item) {
				console.log('333', item)
				console.log(item, this.count)

        //添加锅圈食汇库存提醒
        if (item.title.includes("锅圈食汇")){
        this.$emit('showStockMsg');
        return;
      }


				// 已使用
				if (item.useState === '1') {
					return
				}
				// 0次选择机会｜下月使用
				if (item.goodsType == 1) {
					this.$router.push({
						name: 'discountsDetail',
						params: {
							id: item.id,
							outCouponId: item.couponId,
							num: item.count,
							regionNo: this.regionNo,
							goodsType: item.goodsType
						}
					})
				} else {
					if ((item.useState === '0' && this.count === 0) || item.useState === '2') {
						this.$emit('showMsg')
					} else {
						this.$router.push({
							name: 'discountsDetail',
							params: {
								id: item.id,
								outCouponId: item.couponId,
								num: item.count,
								regionNo: this.regionNo,
								goodsType: item.goodsType
							}
						})
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.discount {
		margin: 16px 30px;
		padding-bottom: 22px;
		display: flex;
		flex-direction: column;
		&-item {
			background: linear-gradient(126deg, #fff8f2 0%, rgba(255, 222, 209, 0.56) 100%);
			border-radius: 24px 24px 24px 24px;
			padding: 24px 26px 24px 28px;
			margin: 16px 0;
			display: flex;
			position: relative;
		}
		&-img {
			width: 176px;
			height: 176px;
			object-fit: cover;
			border-radius: 24px;
			display: block;
			align-self: center;
		}
		&-right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			flex: 1;
			margin-left: 24px;
		}
		&-title {
			color: #3f2a20;
			font-size: 36px;
      font-family: "Alibaba PuHuiTi 2.0", "Alibaba PuHuiTi 20", sans-serif; /* 设置字体 */

    }
		&-content {
			color: #8a3939;
			font-size: 24px;
		}
		&-footer {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
		}
		&-amount {
			color: #dd5701;
			font-size: 35px;
			margin-right: 10px;
			flex-shrink: 0;
			display: flex;
			align-items: flex-end;
			span {
				font-size: 68px;
				font-weight: bold;
				margin-right: 6px;
				line-height: 1;
			}
		}
		&-btn {
			color: #fff;
			background: url('~@/static/images/vip_discounts/btn.png') no-repeat;
			background-size: cover;
			width: 250px;
			height: 80px;
			line-height: 80px;
			text-align: center;
			font-size: 28px;
		}
		&-received {
			background: #fff;
			border-radius: 32px;
			color: #dd5701;
			width: 222px;
			height: 60px;
			line-height: 60px;
		}
		&-count {
			position: absolute;
			right: 0;
			top: -16px;
			width: 112px;
			height: 44px;
			line-height: 44px;
			background: linear-gradient(90deg, #ffb260 0%, #fb7019 100%);
			border-radius: 0 20px 0 20px;
			color: #fff;
			font-size: 26px;
			text-align: center;
		}
	}
</style>
